export class SecurityFileDiff {

  public fileSize: number;
  public date: Date;
  public diff: any;

}
